Ext.define('SA.lq.view.AttributeSelector', {
    alias: 'widget.lq-attribute-selector',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'sa-text-field',
            clearButton: true,
            cls: 'sa-lq-attribute-selector-text-field',
            emptyText: 'Filter',
            icon: true,
            itemId: 'textField',
            ui: 'compact'
        }, {
            xtype: 'component',
            itemId: 'listCmp',

            tpl: [
                '<tpl for=".">',
                    '<div data-attribute-id="{id:htmlEncode}" class="sa-lq-attribute-selector-list-item">{label:htmlEncode} {badgesHtml}</div>',
                '</tpl>'
            ]
        }
    ],

    refreshItems() {
        var text = this.textField.getValue(),
            textParts = Ext.Array.clean(text.split(/[^\w%#$]/)),
            regexString = ('(?=.*' + textParts.join(')(?=.*') + ')').replace(/\$/g, '\\$'),
            regex = new RegExp(regexString, 'i'),
            matchedAttributes = this.data.filter(attribute => attribute.label.match(regex));

        this.listCmp.update(matchedAttributes);
    },

    setItemClickHandler(handler) {
        var getAttributeId = el => el.getAttribute('data-attribute-id'),
            onClick = (ev, target) => handler(getAttributeId(target));

        this.el.on('click', onClick, null, {delegate: '.sa-lq-attribute-selector-list-item'});
    },

    setState(state) {
        this.el.ifCls(state.hasMaxConditions(), 'sa-lq-attribute-selector-disabled');

        this.data = state.getSelectableAttributes().map(attribute => ({
            id: attribute.getId(),
            label: attribute.getLabel(),
            badgesHtml: SA.AttributeBadges.getHtml({attribute: attribute.getId()})
        }));

        this.refreshItems();
    }
});